import React, { useEffect, useId, useRef } from 'react';
import { X } from 'lucide-react';

const ANCHOS = { md: 'max-w-md', lg: 'max-w-2xl', xl: 'max-w-4xl' };
const TONOS = {
  azul: 'bg-blue-50 text-blue-600',
  rojo: 'bg-red-50 text-red-600',
  verde: 'bg-green-50 text-green-600'
};

// Ventana modal del módulo: Esc o clic fuera cierran, salvo mientras
// "bloqueado" (por ejemplo, guardando). El clic fuera tampoco cierra si el
// usuario ya escribió en algún campo, para no perder lo digitado.
const Modal = ({ titulo, subtitulo, icono: Icono, tono = 'azul', onClose, bloqueado = false, ancho = 'lg', pie, children }) => {
  const idTitulo = useId();
  const modificado = useRef(false);

  useEffect(() => {
    const origen = document.activeElement;
    return () => { if (origen && origen.focus) origen.focus(); };
  }, []);

  useEffect(() => {
    const alPresionar = (e) => { if (e.key === 'Escape' && !bloqueado) onClose(); };
    document.addEventListener('keydown', alPresionar);
    return () => document.removeEventListener('keydown', alPresionar);
  }, [onClose, bloqueado]);

  return (
    <div
      className="fixed inset-0 bg-black/40 backdrop-blur-[2px] flex items-center justify-center z-50 p-4"
      onClick={() => !bloqueado && !modificado.current && onClose()}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby={idTitulo}
        onInput={() => { modificado.current = true; }}
        onClick={(e) => e.stopPropagation()}
        className={`bg-white rounded-2xl shadow-2xl w-full ${ANCHOS[ancho]} max-h-[90vh] flex flex-col overflow-hidden`}
      >
        <div className="px-6 pt-5 pb-4 flex items-start gap-3 border-b border-gray-100">
          {Icono && (
            <div className={`${TONOS[tono] || TONOS.azul} rounded-xl p-2 flex-shrink-0`}>
              <Icono size={20} />
            </div>
          )}
          <div className="flex-1 min-w-0">
            <h3 id={idTitulo} className="text-lg font-semibold text-gray-900">{titulo}</h3>
            {subtitulo && <p className="text-sm text-gray-500 truncate">{subtitulo}</p>}
          </div>
          <button
            type="button"
            onClick={onClose}
            disabled={bloqueado}
            aria-label="Cerrar"
            className="text-gray-400 hover:text-gray-600 rounded-lg p-1 outline-none focus-visible:ring-2 focus-visible:ring-blue-500"
          >
            <X size={18} />
          </button>
        </div>
        <div className="px-6 py-5 overflow-y-auto">{children}</div>
        {pie && <div className="px-6 py-4 bg-gray-50 border-t border-gray-100 flex justify-end gap-2">{pie}</div>}
      </div>
    </div>
  );
};

export default Modal;
